(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54844,598],{

/***/ 31808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fk": function() { return /* binding */ detectFlexGapSupported; },
/* harmony export */   "jD": function() { return /* binding */ canUseDocElement; }
/* harmony export */ });
/* unused harmony export isStyleSupport */
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98924);

var canUseDocElement = function canUseDocElement() {
  return (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported() {
  if (!canUseDocElement()) {
    return false;
  }

  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  document.body.removeChild(flex);
  return flexGapSupported;
};

/***/ }),

/***/ 63317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar",
      function () {
        return __webpack_require__(85248);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_calendar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/features/calendar/CalendarHeader/CalendarHeader.tsx + 5 modules
var CalendarHeader = __webpack_require__(99352);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/calendar/Table.js
var Table = __webpack_require__(27087);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/calendar/utils.tsx
var utils = __webpack_require__(96229);
;// CONCATENATED MODULE: ./src/features/calendar/type.ts
var CalendarTodayEnums;
(function(CalendarTodayEnums) {
    CalendarTodayEnums["CUM_DATE"] = "Cum Date";
    CalendarTodayEnums["EX_DATE"] = "Ex Date";
    CalendarTodayEnums["PAY_DATE"] = "Pay Date";
    CalendarTodayEnums["TRADING_START"] = "Trading Start";
    CalendarTodayEnums["TRADING_END"] = "Trading End";
    CalendarTodayEnums["EXERCISE_START"] = "Exercise Start";
    CalendarTodayEnums["EXERCISE_END"] = "Exercise End";
    CalendarTodayEnums["OFFERING_START"] = "Offering Start";
    CalendarTodayEnums["OFFERING_END"] = "Offering End";
})(CalendarTodayEnums || (CalendarTodayEnums = {}));
var CalendarTodayDataIndexEnums;
(function(CalendarTodayDataIndexEnums) {
    CalendarTodayDataIndexEnums["ECONCAL_EDITTED_SYMBOL"] = "econcal_editted_symbol";
    CalendarTodayDataIndexEnums["ECONCAL_EDITTED_TIME"] = "econcal_editted_time";
    CalendarTodayDataIndexEnums["COMPANY_SYMBOL"] = "company_symbol";
    CalendarTodayDataIndexEnums["STOCKSPLIT_ADDED_OLD_NEW"] = "stocksplit_added_old_new";
    CalendarTodayDataIndexEnums["RIGHTISSUE_ADDED_OLD_NEW"] = "rightissue_added_old_new";
    CalendarTodayDataIndexEnums["DIVIDEND_VALUE"] = "dividend_value_formatted";
    CalendarTodayDataIndexEnums["STOCKSPLIT_RATIO"] = "stocksplit_ratio";
    CalendarTodayDataIndexEnums["RIGHTISSUE_RATIO"] = "rightissue_ratio";
    CalendarTodayDataIndexEnums["RIGHTISSUE_PRICE"] = "rightissue_price";
    CalendarTodayDataIndexEnums["BONUS_RATIO"] = "sahambonus_ratio";
    CalendarTodayDataIndexEnums["WARRANT_EXC_PRICE"] = "wrant_exc_price";
    CalendarTodayDataIndexEnums["TENDER_PRICE"] = "tender_price";
    CalendarTodayDataIndexEnums["RUPS_TIME"] = "rups_time";
    CalendarTodayDataIndexEnums["PUEXP_TIME"] = "puexp_time";
    CalendarTodayDataIndexEnums["COMPANY_NAME"] = "company_name";
    CalendarTodayDataIndexEnums["IPO_PRICE"] = "ipo_price";
})(CalendarTodayDataIndexEnums || (CalendarTodayDataIndexEnums = {}));

// EXTERNAL MODULE: ./src/features/calendar/slice.ts + 1 modules
var slice = __webpack_require__(39246);
// EXTERNAL MODULE: ./src/features/calendar/CalendarBody/CalendarBody.tsx
var CalendarBody = __webpack_require__(5120);
// EXTERNAL MODULE: ./src/features/calendar/styled.tsx
var styled = __webpack_require__(75290);
// EXTERNAL MODULE: ./src/features/calendar/constants.ts
var constants = __webpack_require__(2230);
;// CONCATENATED MODULE: ./src/features/calendar/CalendarType/Today.tsx


















var CURRENCY_LIST = {
    CURRENCY_IDR: "Rp ",
    CURRENCY_USD: "USD ",
    CURRENCY_UNSPECIFIED: ""
};
var DEFAULT_TODAY = (0,format/* default */.Z)(new Date(), constants/* DATE_FORMAT */.zT);
var TEXT_CALENDAR_TODAY = CalendarTodayEnums;
var DATA_INDEX_CALENDAR_TODAY = CalendarTodayDataIndexEnums;
var _obj;
var dataGenerator = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX, function(rawData) {
    var result = rawData.map(function(eco, index) {
        var time = "";
        if (eco.econcal_time) {
            var ref = (0,_sliced_to_array/* default */.Z)(eco.econcal_time.split(":"), 2), hours = ref[0], minutes = ref[1];
            time = "".concat(hours, ":").concat(minutes);
        }
        var _obj;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eco), (_obj = {}, (0,_define_property/* default */.Z)(_obj, DATA_INDEX_CALENDAR_TODAY.ECONCAL_EDITTED_TIME, time), (0,_define_property/* default */.Z)(_obj, DATA_INDEX_CALENDAR_TODAY.ECONCAL_EDITTED_SYMBOL, "".concat(eco.econcal_item, "  (").concat(eco.econcal_month, ")")), _obj));
    });
    return result;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX, function(rawData) {
    return rawData;
}), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX, function(rawData) {
    var result = rawData.map(function(ipo) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ipo), (0,_define_property/* default */.Z)({}, DATA_INDEX_CALENDAR_TODAY.IPO_PRICE, JSON.parse(ipo.ipo_data).Price));
    });
    return result;
}), _obj);
var columnSymbolRender = utils/* symbolCustomRender */.F;
var CalendarStreamline = function(param) {
    var title = param.title, dataSources = param.dataSources, columns = param.columns, rowKey = param.rowKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SubTitle */.DK, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                showHeader: false,
                dataSource: dataSources,
                columns: columns,
                rowKey: rowKey
            })
        ]
    });
};
var CalendarToday = function() {
    var ref = (0,react.useState)(), calendar = ref[0], setCalendar = ref[1];
    var ref1 = (0,react.useState)([]), economicToday = ref1[0], setEconomicToday = ref1[1];
    var ref2 = (0,react.useState)([]), dividendToday = ref2[0], setDividendToday = ref2[1];
    var ref3 = (0,react.useState)([]), stocksplitToday = ref3[0], setStocksplitToday = ref3[1];
    var ref4 = (0,react.useState)([]), reverseSplitToday = ref4[0], setReverseSplitToday = ref4[1];
    var ref5 = (0,react.useState)([]), rightIssueToday = ref5[0], setRightIssueToday = ref5[1];
    var ref6 = (0,react.useState)([]), warrantToday = ref6[0], setWarrantToday = ref6[1];
    var ref7 = (0,react.useState)([]), bonusToday = ref7[0], setBonusToday = ref7[1];
    var ref8 = (0,react.useState)([]), tenderofferToday = ref8[0], setTenderofferToday = ref8[1];
    var ref9 = (0,react.useState)([]), rupsToday = ref9[0], setRupsToday = ref9[1];
    var ref10 = (0,react.useState)([]), pubexToday = ref10[0], setPubexToday = ref10[1];
    var ref11 = (0,react.useState)([]), ipoToday = ref11[0], setIpoToday = ref11[1];
    var ref12 = (0,react.useState)(DEFAULT_TODAY), today = ref12[0], setToday = ref12[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var calendarToday = (0,es/* useSelector */.v9)(slice/* selectors */.wl).calendarToday;
    var getCalendarItem = function(array) {
        var found = array.find(function(item) {
            return !!(item === null || item === void 0 ? void 0 : item[today]);
        });
        return (found === null || found === void 0 ? void 0 : found[today]) || "";
    };
    var columnDividendRender = function(_text, record) {
        var dividendList = [
            (0,_define_property/* default */.Z)({}, record.dividend_cumdate, TEXT_CALENDAR_TODAY.CUM_DATE),
            (0,_define_property/* default */.Z)({}, record.dividend_exdate, TEXT_CALENDAR_TODAY.EX_DATE), 
        ];
        var result = getCalendarItem(dividendList);
        return {
            children: result
        };
    };
    var columnStocksplitRender = function(_text, record) {
        var stocksplitList = [
            (0,_define_property/* default */.Z)({}, record.stocksplit_cumdate, TEXT_CALENDAR_TODAY.CUM_DATE),
            (0,_define_property/* default */.Z)({}, record.stocksplit_exdate, TEXT_CALENDAR_TODAY.EX_DATE), 
        ];
        var result = getCalendarItem(stocksplitList);
        return {
            children: result
        };
    };
    var columnRightIssueRender = function(_text, record) {
        var rightIssueList = [
            (0,_define_property/* default */.Z)({}, record.rightissue_cumdate, TEXT_CALENDAR_TODAY.CUM_DATE),
            (0,_define_property/* default */.Z)({}, record.rightissue_exdate, TEXT_CALENDAR_TODAY.EX_DATE),
            (0,_define_property/* default */.Z)({}, record.rightissue_trading_start, TEXT_CALENDAR_TODAY.TRADING_START),
            (0,_define_property/* default */.Z)({}, record.rightissue_trading_end, TEXT_CALENDAR_TODAY.TRADING_END), 
        ];
        var result = getCalendarItem(rightIssueList);
        return {
            children: result
        };
    };
    var columnWarrantRender = function(_text, record) {
        var warrantList = [
            (0,_define_property/* default */.Z)({}, record.wrant_trading_from, TEXT_CALENDAR_TODAY.TRADING_START),
            (0,_define_property/* default */.Z)({}, record.wrant_trading_end, TEXT_CALENDAR_TODAY.TRADING_END),
            (0,_define_property/* default */.Z)({}, record.wrant_exc_from, TEXT_CALENDAR_TODAY.EXERCISE_START),
            (0,_define_property/* default */.Z)({}, record.wrant_exc_end, TEXT_CALENDAR_TODAY.EXERCISE_END), 
        ];
        var result = getCalendarItem(warrantList);
        return {
            children: result
        };
    };
    var columnTenderOfferRender = function(_text, record) {
        var tenderOfferList = [
            (0,_define_property/* default */.Z)({}, record.tender_start, TEXT_CALENDAR_TODAY.OFFERING_START),
            (0,_define_property/* default */.Z)({}, record.tender_end, TEXT_CALENDAR_TODAY.OFFERING_END),
            (0,_define_property/* default */.Z)({}, record.tender_paydate, TEXT_CALENDAR_TODAY.PAY_DATE), 
        ];
        var result = getCalendarItem(tenderOfferList);
        return {
            children: result
        };
    };
    var renderPrice = function(text) {
        return numeral_default()(Number(text)).format("0,0[.]00");
    };
    var _obj;
    var columnGenerator = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.ECONCAL_EDITTED_SYMBOL,
            width: "20%"
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.ECONCAL_EDITTED_TIME
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.DIVIDEND_VALUE,
            render: function(text, record) {
                return {
                    children: "".concat(text || "".concat(CURRENCY_LIST[record.dividend_currency]).concat(record.dividend_value), " / Saham")
                };
            }
        },
        {
            render: columnDividendRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.STOCKSPLIT_RATIO
        },
        {
            render: columnStocksplitRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.STOCKSPLIT_RATIO
        },
        {
            render: columnStocksplitRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.RIGHTISSUE_RATIO
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.RIGHTISSUE_PRICE,
            render: function(text) {
                return {
                    children: "Rp. ".concat(renderPrice(text))
                };
            }
        },
        {
            render: columnRightIssueRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.WARRANT_EXC_PRICE,
            render: function(text) {
                return {
                    children: "Rp. ".concat(renderPrice(text))
                };
            }
        },
        {
            render: columnWarrantRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.BONUS_RATIO
        },
        {
            render: columnStocksplitRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.TENDER_PRICE,
            render: function(text) {
                return {
                    children: "Rp. ".concat(Number(text).toLocaleString())
                };
            }
        },
        {
            render: columnTenderOfferRender
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.RUPS_TIME
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_SYMBOL,
            width: "20%",
            render: columnSymbolRender
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.PUEXP_TIME,
            render: function(text) {
                return {
                    children: (text === null || text === void 0 ? void 0 : text.slice(0, 5)) || ""
                };
            }
        }, 
    ]), (0,_define_property/* default */.Z)(_obj, constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX, [
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.COMPANY_NAME,
            width: "20%"
        },
        {
            dataIndex: DATA_INDEX_CALENDAR_TODAY.IPO_PRICE,
            render: function(text) {
                return {
                    children: "Rp. ".concat(Number(text.replace(",", "")).toLocaleString())
                };
            }
        }, 
    ]), _obj);
    var getDataFromDataGenerator = function(calendarData, calendarType) {
        if (calendarData === null || calendarData === void 0 ? void 0 : calendarData.data) {
            var _data = calendarData.data, newCalendarType = _data[calendarType];
            return dataGenerator[calendarType](newCalendarType);
        }
        return [];
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* effects.getCalendarToday */.Sz.getCalendarToday());
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        setCalendar(calendarToday);
    }, [
        calendarToday
    ]);
    (0,react.useEffect)(function() {
        setEconomicToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX);
        });
        setDividendToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX);
        });
        setStocksplitToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX);
        });
        setReverseSplitToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX);
        });
        setRightIssueToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX);
        });
        setWarrantToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX);
        });
        setBonusToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX);
        });
        setTenderofferToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX);
        });
        setRupsToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX);
        });
        setPubexToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX);
        });
        setIpoToday(function() {
            return getDataFromDataGenerator(calendar, constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX);
        });
        setToday(function() {
            if (calendar === null || calendar === void 0 ? void 0 : calendar.data) {
                var ref;
                return (ref = calendar.data) === null || ref === void 0 ? void 0 : ref.today;
            }
            return DEFAULT_TODAY;
        });
    }, [
        calendar
    ]);
    var _obj1;
    var calendarDataList = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.ECONOMIC.TITLE */.OV.ECONOMIC.TITLE,
        dataSources: economicToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.ECONOMIC.ROW_KEY */.OV.ECONOMIC.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.DIVIDEND.TITLE */.OV.DIVIDEND.TITLE,
        dataSources: dividendToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.DIVIDEND.ROW_KEY */.OV.DIVIDEND.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.TITLE */.OV.STOCKSPLIT.TITLE,
        dataSources: stocksplitToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.ROW_KEY */.OV.STOCKSPLIT.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.TITLE */.OV.STOCK_REVERSE.TITLE,
        dataSources: reverseSplitToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.ROW_KEY */.OV.STOCK_REVERSE.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.TITLE */.OV.RIGHT_ISSUE.TITLE,
        dataSources: rightIssueToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.ROW_KEY */.OV.RIGHT_ISSUE.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.WARRANT.TITLE */.OV.WARRANT.TITLE,
        dataSources: warrantToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.WARRANT.ROW_KEY */.OV.WARRANT.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.BONUS.TITLE */.OV.BONUS.TITLE,
        dataSources: bonusToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.BONUS.ROW_KEY */.OV.BONUS.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.TITLE */.OV.TENDER_OFFER.TITLE,
        dataSources: tenderofferToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.ROW_KEY */.OV.TENDER_OFFER.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.RUPS.TITLE */.OV.RUPS.TITLE,
        dataSources: rupsToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.RUPS.ROW_KEY */.OV.RUPS.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.PUBEX.TITLE */.OV.PUBEX.TITLE,
        dataSources: pubexToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.PUBEX.ROW_KEY */.OV.PUBEX.ROW_KEY
    }), (0,_define_property/* default */.Z)(_obj1, constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX, {
        title: constants/* CALENDAR_TODAY_TYPE.IPO.TITLE */.OV.IPO.TITLE,
        dataSources: ipoToday,
        columns: columnGenerator[constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX],
        rowKey: constants/* CALENDAR_TODAY_TYPE.IPO.ROW_KEY */.OV.IPO.ROW_KEY
    }), _obj1);
    var renderCalendarStreamline = function(calendarName) {
        var _calendarName = calendarDataList[calendarName], title = _calendarName.title, dataSources = _calendarName.dataSources, columns = _calendarName.columns, rowKey = _calendarName.rowKey;
        if (dataSources.length) {
            return CalendarStreamline({
                title: title,
                dataSources: dataSources,
                columns: columns,
                rowKey: rowKey
            });
        }
        return null;
    };
    var isEmpty = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        if ((calendar === null || calendar === void 0 ? void 0 : calendar.data) && ((ref = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX]) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX]) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 && ((ref2 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX]) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && ((ref3 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX]) === null || ref3 === void 0 ? void 0 : ref3.length) === 0 && ((ref4 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX]) === null || ref4 === void 0 ? void 0 : ref4.length) === 0 && ((ref5 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX]) === null || ref5 === void 0 ? void 0 : ref5.length) === 0 && ((ref6 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX]) === null || ref6 === void 0 ? void 0 : ref6.length) === 0 && ((ref7 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX]) === null || ref7 === void 0 ? void 0 : ref7.length) === 0 && ((ref8 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX]) === null || ref8 === void 0 ? void 0 : ref8.length) === 0 && ((ref9 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX]) === null || ref9 === void 0 ? void 0 : ref9.length) === 0 && ((ref10 = calendar === null || calendar === void 0 ? void 0 : calendar.data[constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX]) === null || ref10 === void 0 ? void 0 : ref10.length) === 0) {
            return true;
        }
        return false;
    }, [
        calendar
    ]);
    if (isEmpty) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* EmptyCalendarWrapper */.XG, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/illustration/calendar-empty.svg",
                    alt: "empty"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mt: "10px",
                    color: "#858585",
                    children: "There Are No Scheduled Events Today"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBody/* default */.Z, {
        children: [
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.ECONOMIC.INDEX */.OV.ECONOMIC.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.DIVIDEND.INDEX */.OV.DIVIDEND.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.STOCKSPLIT.INDEX */.OV.STOCKSPLIT.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.STOCK_REVERSE.INDEX */.OV.STOCK_REVERSE.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.RIGHT_ISSUE.INDEX */.OV.RIGHT_ISSUE.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.WARRANT.INDEX */.OV.WARRANT.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.BONUS.INDEX */.OV.BONUS.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.TENDER_OFFER.INDEX */.OV.TENDER_OFFER.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.RUPS.INDEX */.OV.RUPS.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.PUBEX.INDEX */.OV.PUBEX.INDEX),
            renderCalendarStreamline(constants/* CALENDAR_TODAY_TYPE.IPO.INDEX */.OV.IPO.INDEX)
        ]
    });
};
/* harmony default export */ var Today = (CalendarToday);

;// CONCATENATED MODULE: ./src/features/calendar/index.tsx




var Calendar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarHeader/* default */.Z, {
                title: "Today",
                activeMenu: "Today"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Today, {})
        ]
    });
};
/* harmony default export */ var calendar = (Calendar);

// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Page.tsx
var Page = __webpack_require__(16943);
;// CONCATENATED MODULE: ./pages/calendar.tsx

__webpack_require__(14473);







var calendar_Calendar = function() {
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Calendar Corporate Action Indonesia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                        loaded: isLoaded
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                        feature: "CALENDAR",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_calendar = (calendar_Calendar);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "Gi": function() { return /* binding */ CustomTable; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "XG": function() { return /* binding */ EmptyCalendarWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_calendar_Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27087);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media screen and (max-width: 720px) {\n        .ant-table-cell-fix-left-last {\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: var(--regular-font);\n\n  .today {\n    & .today-column {\n      font-family: var(--bold-font);\n      font-weight: 700;\n    }\n  }\n  .today td {\n    background-color: #d5ead7;\n  }\n\n  .yesterday {\n    color: ",
        ";\n  }\n\n  .text--bold {\n    font-family: var(--bold-font);\n    font-weight: 700;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n\n  :first-child {\n    border-top: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 990px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  height: 500px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "bold",
    weight: 700
}).withConfig({
    componentId: "sc-3b94f7a0-0"
})(_templateObject());
var CustomTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_calendar_Table__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3b94f7a0-1"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].darkGray */ .Z.darkGray, function(props) {
    // @ts-expect-error
    return (props === null || props === void 0 ? void 0 : props.isIpo) && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1());
});
var SubTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    padding: "15px 10px",
    family: "bold"
}).withConfig({
    componentId: "sc-3b94f7a0-2"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var EmptyCalendarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3b94f7a0-3"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);



/***/ }),

/***/ 96229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ symbolCustomRender; },
/* harmony export */   "J": function() { return /* binding */ dateCustomRender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42298);
/* harmony import */ var constants_data_cy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70524);







var symbolCustomRender = function(text) {
    var symbol = text.toUpperCase();
    return {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "/symbol/".concat(symbol),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "a",
                href: "/symbol/".concat(symbol),
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                "data-cy": "".concat(constants_data_cy__WEBPACK_IMPORTED_MODULE_4__/* ["default"].CALENDAR.ROW_SYMBOL */ .Z.CALENDAR.ROW_SYMBOL, "-").concat(symbol),
                children: symbol
            })
        })
    };
};
var dateCustomRender = function(text) {
    var bold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(text.split("-"), 3), year = ref[0], rawMonth = ref[1], day = ref[2];
    var month = Number(rawMonth) - 1;
    var today = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(), "d MMM yy");
    var formattedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(Number(year), Number(month), Number(day)), "d MMM yy");
    var isToday = today === formattedDate && bold;
    return {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: isToday && "today-column",
            color: "inherit",
            children: formattedDate
        })
    };
};


/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_usePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31837);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75850);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67857);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35921);






function PaywallWrapper(param) {
    var children = param.children, feature = param.feature, isFlexible = param.isFlexible, isWidget = param.isWidget;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isReady = ref[0], setReady = ref[1];
    var ref1 = (0,_store_usePage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        featureKey: feature
    }), isPro = ref1.isPro, isLoading = ref1.isLoading, isRenewal = ref1.isRenewal;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReady(true);
    }, []);
    if (isLoading || !isReady) {
        return null;
    }
    if (isPro) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PaywallPageWrapper */ .qh, {
        isFlexible: isFlexible,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            source: _analytics__WEBPACK_IMPORTED_MODULE_4__/* .PageAnalytics */ .oF[feature],
            isRenewal: isRenewal,
            isWidget: isWidget,
            height: "272px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWrapper);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp10 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 31837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92182);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5072);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11298);





function usePage(param) {
    var featureKey = param.featureKey, _pauseCounter = param.pauseCounter, pauseCounter = _pauseCounter === void 0 ? false : _pauseCounter;
    var ref = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(state) {
        return {
            isPro: state.page.isPro,
            isLoading: state.page.isLoading,
            isRenewal: state.page.isRenewal,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isPro = ref.isPro, isLoading = ref.isLoading, isRenewal = ref.isRenewal, getStatus = ref.getStatus, addCounter = ref.addCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var KEY = featureKey.toUpperCase();
        var featureName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .PaywallFeatureEnum */ .qU[KEY];
        if (!featureName) return;
        if (!pauseCounter) addCounter({
            feature: featureName
        });
        getStatus({
            key: _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionEnum.page */ .P.page,
            feature: featureName
        });
    }, [
        featureKey,
        pauseCounter
    ]);
    return {
        isPro: isPro,
        isLoading: isLoading,
        isRenewal: isRenewal
    };
};


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 60374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shallow; }
/* harmony export */ });
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}




/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 17172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,46819,88069,7648,25935,51225,80129,80737,40142,77549,50299,92961,91036,54253,54005,33070,58928,92077,79931,42298,20335,44912,81273,21671,74768,12786,77284,74673,54565,49774,92888,40179], function() { return __webpack_exec__(63317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);